import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import * as ptBR from '../i18n/ptBR';

i18n.use(initReactI18next).init({
  debug: false,
  fallbackLng: 'pt-BR',
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources: {
    'pt-BR': {
      ...ptBR,
    },
  },
});

export default i18n;
